const dollars = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

// Use actual household assignments, not tier counts (ranges may overlap).
export function foodVoucherTotal(rows) {
  if (!Array.isArray(rows)) return null;
  let cents = 0;
  for (const row of rows) {
    const amount = row?.tier_amount;
    if (amount == null || (typeof amount === "string" && !amount.trim())) continue;
    if (typeof amount !== "number" && typeof amount !== "string") return null;
    const value = Number(amount);
    if (!Number.isFinite(value) || value < 0) return null;
    cents += Math.round(value * 100);
    if (!Number.isSafeInteger(cents)) return null;
  }
  return dollars.format(cents / 100);
}
